module.exports = __webpack_public_path__ + "static/media/view patient.76c68b24.svg";